module.exports = __webpack_public_path__ + "img/clock-fast-forward.ff760526.svg";